import React from 'react';
import {
  func, shape, string, arrayOf, bool,
} from 'prop-types';
import { isEmpty } from 'lodash';
import { Button, Tooltip } from '@material-ui/core';

import TinyLineChart from '../../../components/Chart';
import Block from '../../../components/Block';
import Statistic from '../../../components/Statistic';
import Skeleton from '../../../components/Skeleton';

import { getTinyLineSettings } from '../utils/chartSettings';
import IntlMessages from '../../../utils/IntlMessages';
import disableEventsOnScroll from '../../../utils/disableEventsOnScroll';
import StatisticTitle from './StatisticTitle';
import getRate from '../../../utils/getRate';

const Charts = (props) => {
  const { chartList, loading } = props;
  const scrollFadeClass = !isEmpty(chartList) && chartList.length > 15 ? 'scroll-fade-before scroll-fade-after' : '';
  const scrollClass = !isEmpty(chartList) && chartList.length > 15 ? 'scroll-y scroll-70' : '';
  let disabledChart = false;

  const enableActions = props.chartList.length > 1;
  const selectedChart = props.chartList.length === 1
    ? props.chartList[0]
    : props.selected;

  const chartClass = enableActions ? '' : 'cursor-default';

  return (
    isEmpty(chartList)
      ? (
        !loading && (
          <Skeleton
            type="chartCard"
            message={<IntlMessages id="text.noResult" />}
          />
        )
      )
      : (
        <div className={`container container-fluid pb35 ${scrollFadeClass}`}>
          <div
            id="scrollContainer"
            className={`flex flex-wrap rct-block-row ${scrollClass}`}
            onScroll={disableEventsOnScroll('scrollContainer')}
          >
            {!isEmpty(chartList) && chartList.map((chart) => {
              const data = getRate(chart.errors.current, chart.errors.prev);
              const selectedChartClass = !isEmpty(selectedChart) && chart.id === selectedChart.id ? 'chart-active' : '';

              const tinyLineSettings = getTinyLineSettings({ chart });

              disabledChart = selectedChart && !isEmpty(selectedChart)
                && chart.id !== selectedChart.id;

              return (
                <div
                  role="presentation"
                  className={`rct-block-wrapper chart-row ${disabledChart ? 'no-events' : ''}`}
                  key={chartList.indexOf(chart)}
                  onClick={() => (enableActions ? props.onChartClick(chart) : null)}
                >
                  <Block
                    className={`chart-wrapper ${selectedChartClass} ${disabledChart ? 'chart-disabled' : ''} ${chartClass}`}
                    title={(
                      <Statistic
                        title={(
                          <StatisticTitle
                            title={chart.name}
                          />
                        )}
                        className="flex justify-between items-baseline"
                        value={data.value}
                        valueSuffix="%"
                        precision={2}
                        type={data.type}
                        suffix={data.icon}
                      />
                    )}
                  >
                    <div className="chart-title">
                      <Tooltip
                        placement="right"
                        title={(
                          <div className="fz-12">
                            <IntlMessages id="chart.title.rate.prev.label" />
                            {chart.errors.prev}
                          </div>
                        )}
                      >
                        <span>{chart.docCount}</span>
                      </Tooltip>
                    </div>
                    <TinyLineChart
                      responsive
                      className={tinyLineSettings.className}
                      width={tinyLineSettings.width}
                      height={tinyLineSettings.height}
                      fill={tinyLineSettings.fill}
                      sourceData={chart}
                      xAxis={tinyLineSettings.xAxis}
                      yAxis={tinyLineSettings.yAxis}
                      dataKey={tinyLineSettings.dataKey}
                      strokeWidth={tinyLineSettings.strokeWidth}
                      dot={tinyLineSettings.dot}
                    />
                  </Block>
                </div>
              );
            })}
          </div>
          {selectedChart && !isEmpty(selectedChart) && enableActions && (
            <Button
              onClick={props.deleteSelected}
              color="secondary"
              className="btn-xs pos-abs bottom-0 right"
            >
              <IntlMessages id="text.allErrors" />
            </Button>
          )}
        </div>
      )

  );
};

Charts.propTypes = {
  onChartClick: func,
  loading: bool,
  deleteSelected: func,
  selected: shape({
    id: string,
  }),
  chartList: arrayOf(shape({
    key: string,
  })),
};

Charts.defaultProps = {
  selected: {},
  chartList: [],
  loading: false,
  deleteSelected: null,
  onChartClick: null,
};

export default Charts;
